import React from 'react';
import { useTranslation } from 'react-i18next';

function TermsPage() {
    const { t } = useTranslation();

    return (
        <div className="terms-page">
            <section className="text-center lg:py-16" style={{
                border: "1px solid rgba(129, 140, 248, 0.1)",
                borderRadius: "20px",
                background: "linear-gradient(to right, rgba(129, 140, 248, 0.1), transparent, transparent)",
                boxShadow: "0 4px 30px rgba(0, 0, 0, 0.2)",
            }}>
                <div className="max-w-4xl mx-auto">
                    <h1 className="text-4xl md:text-6xl font-bold leading-tight text-gradient">
                        {t('termsPage.title')}
                    </h1>
                    <p className="text-lg md:text-xl lg:py-8 with-shadow">
                        {t('termsPage.subtitle')}
                    </p>
                </div>
            </section>

            <section className="py-20 lg:py-32" id="content">
                <div className="max-w-4xl mx-auto">
                    <div className="mb-8">
                        <p className="text-sm text-gray-600 mb-8">{t('termsPage.lastUpdated')}</p>
                        <p className="text-lg mb-8 with-shadow">{t('termsPage.intro')}</p>
                    </div>

                    <div className="space-y-12">
                        {/* Accettazione dei Termini */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.acceptanceTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.acceptance')}</p>
                        </div>

                        {/* Descrizione del Servizio */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.serviceDescriptionTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.serviceDescription')}</p>
                        </div>

                        {/* Proprietà Intellettuale */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.intellectualPropertyTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.intellectualProperty')}</p>
                        </div>

                        {/* Comportamento degli Utenti */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.userConductTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.userConduct')}</p>
                        </div>

                        {/* Limitazioni e Disclaimer */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.disclaimerTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.disclaimer')}</p>
                        </div>

                        {/* Servizi di Terze Parti */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.thirdPartyTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.thirdParty')}</p>
                        </div>

                        {/* Limitazione di Responsabilità */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.limitationTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.limitation')}</p>
                        </div>

                        {/* Modifiche ai Termini */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.changesTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.changes')}</p>
                        </div>

                        {/* Sospensione del Servizio */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.terminationTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.termination')}</p>
                        </div>

                        {/* Legge Applicabile */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.governingLawTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.governingLaw')}</p>
                        </div>

                        {/* Contatti */}
                        <div>
                            <h2 className="text-2xl font-bold mb-4 main-h-color">{t('termsPage.contactTitle')}</h2>
                            <p className="with-shadow">{t('termsPage.contactInfo')}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default TermsPage;
